export {NotFoundPage} from './not-found/not-found.page';

